import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";

export const GetIntro =
  ({ callback, page, rowsPerPage }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.intro.get + `?limit=${rowsPerPage}&page=${page}`;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteIntro =
  ({ introId, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.intro.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${introId}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageIntro =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
        console.log("2");
      }
      if (CheckDataIfExit(values?.intro_title)) {
        bodyFormData.append("intro_title", values?.intro_title?.trim());
      }
      if (CheckDataIfExit(values?.intro_text)) {
        bodyFormData.append("intro_text", values?.intro_text?.trim());
      }
      if (values?.is_patient_intro == 0 || values?.is_patient_intro == 1) {
        bodyFormData.append("is_patient_intro", values?.is_patient_intro);
      }
      if (
        values?.intro_image &&
        values?.intro_image != null &&
        values?.intro_image != undefined &&
        CheckImageIsFile({ data: values?.intro_image, IsBoolean: true })
      ) {
        bodyFormData.append("intro_image", values?.intro_image);
      } else if (editMode && !values?.intro_image) {
        bodyFormData.append("intro_image", "");
      }
      console.log({ bodyFormDatabodyFormData: bodyFormData });
      console.log("3");
      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode ? `${UrlApi.intro.edit}/${paramID}` : UrlApi.intro.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      console.log("4");
      callback(response);
    } catch (err) {
      console.log("5");
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditIntro =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.intro.edit + `/${id}`,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
